'use client';
import { useCallback, useRef } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import clsx from 'clsx';
import { SvgClose } from '@/components/icons';
import { debounce } from '@/utils/debounce';
import { IWithClassname } from '@/models/common';
import s from './Search.module.scss';

interface Props extends IWithClassname {
  placeholder?: string;
  inputId?: string;
  noCross?: boolean;
}

export const Search = ({ placeholder = 'Поиск', inputId, noCross, className }: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();

  const query = searchParams.get('query');

  const onSearch = (term: string) => {
    if (term.length > 255) return;

    const params = new URLSearchParams(searchParams);
    params.delete('show_more');
    params.set('page', '1');
    if (term) {
      params.set('query', term);
    } else {
      params.delete('query');
    }
    replace(`${pathname}?${params.toString()}`);
  };

  const debouncedSearch = useCallback(debounce(onSearch, 500), [searchParams]);

  const resetSearch = () => {
    if (!inputRef.current) return;
    inputRef.current.value = '';
    onSearch('');
  };

  return (
    <div className={clsx(s.search, className, { [s.search_focused]: query })}>
      <input
        id={inputId || 'search-input'}
        type="text"
        ref={inputRef}
        className={s.input}
        placeholder={placeholder}
        onChange={(e) => debouncedSearch(e.target.value)}
        defaultValue={query?.toString()}
      />

      {!noCross && query && (
        <button className={s.search__resetButton} onClick={resetSearch}>
          <SvgClose />
        </button>
      )}

      {/*<button className={clsx(s.search__button, { [s.search__button_disabled]: !query })}>*/}
      {/*  Поиск <ArrowSvg />*/}
      {/*</button>*/}
    </div>
  );
};